// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__1_8XK","total":"Cart_total__kLBhR","actions":"Cart_actions__3XKbl","button--alt":"Cart_button--alt__2tcrx","button":"Cart_button__1NW3n"};